@if (show) {
  <div class="loader-overlay">
    @if (show) {
      <div class="loader">
        <div class="progress" [ngStyle]="{ width: width }"></div>
      </div>
    }
  </div>
}
